// extracted by mini-css-extract-plugin
export default {"flex":"BS","imgwrap":"CS","image":"ES","textinfo":"FS","producttitle":"GS","bolder":"HS","block":"IS","info":"JS","moredetails":"KS","whitebox":"LS","old_price":"MS","discount":"NS"};
    if(module.hot) {
      // 1714422957044
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  